import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import queryString from 'query-string';

export default function setShippingAddress(params) {
    const { baseUrl, brandId, country, addressId, uberToken, clientId, clientSecret, clearMessages = true, langId, additionalHeaders = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of setShippingAddress()');
    invariant(brandId, 'brandId is a required param of setShippingAddress()');
    invariant(country, 'country is a required param of setShippingAddress()');
    invariant(addressId, 'addressId is a required param of setShippingAddress()');
    invariant(uberToken, 'uberToken is a required param of setShippingAddress()');
    invariant(clientId, 'clientId is a required param of setShippingAddress()');

    const headers = { 'X-Ubertoken': uberToken, 'Content-Type': 'application/json', ...additionalHeaders };
    const query = queryString.stringify({ clearMessages, langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart/@self/shipping_info?${query}`;
    const body = JSON.stringify({ addressId: addressId ? addressId.toString() : null });

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'PUT', body }), uberToken, clientId, clientSecret),
        'setShippingAddress',
    );
}
